import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <>
      {/* Footer & Contact */}
      <footer className="footer">
        <div className="container">
          <div className="row">
            <div className="col-md-4 mb-4">
              {/* Logo + Brand Name */}
              <div className="d-flex align-items-center gap-2 mb-3">
                <div className="footer-logo">
                  <div className="d-flex align-items-center gap-2 mb-3">
                    <img
                      src="/images/white_logo.png"
                      alt="FORMAX MONEY Logo"
                      style={{ height: "40px", width: "auto" }}
                    />
                  </div>
                </div>
              </div>
              <p className="small">
                Formax IT Solutions Pvt. Ltd. is a licensed Corporate Business
                Correspondent (CBC) providing AEPS, DMT, and CMS services
                through its agent network, enabling easy access to banking in
                underserved areas.
              </p>
              <p className="small mb-1">
                <strong>CIN:</strong> U72900WB2018PTC228240
              </p>
              <p className="small mb-1">
                <strong>GSTIN:</strong> 19AADCF5125F1ZT
              </p>
              <p className="small mb-0">
                <strong>Email:</strong> support@formaxmoney.in
              </p>
            </div>
            <div className="col-md-2 mb-4">
              <h6 className="text-white mb-3">Quick Links</h6>
              <ul className="list-unstyled small">
                <li className="mb-2">
                  <Link to="/" className="text-decoration-none text-white-50">
                    Home
                  </Link>
                </li>
                <li className="mb-2">
                  <a
                    href="/services"
                    className="text-decoration-none text-white-50"
                  >
                    Services
                  </a>
                </li>
                <li className="mb-2">
                  <a
                    href="/about-us"
                    className="text-decoration-none text-white-50"
                  >
                    About Us
                  </a>
                </li>
              </ul>
            </div>
            <div className="col-md-3 mb-4">
              <h6 className="text-white mb-3">Services</h6>
              <ul className="list-unstyled small">
                <li className="mb-2">AEPS</li>
                <li className="mb-2">Micro ATM</li>
                <li className="mb-2">DMT</li>
                <li className="mb-2">CMS</li>
                <li className="mb-2">UPI Cash Point</li>
              </ul>
            </div>
            <div className="col-md-3 mb-4">
              <h6 className="text-white mb-3">Legal</h6>
              <ul className="list-unstyled small">
                <li className="mb-2">
                  <a
                    href="/terms-and-conditions"
                    className="text-decoration-none text-white-50"
                  >
                    Terms &amp; Conditions
                  </a>
                </li>
                <li className="mb-2">
                  <a
                    href="/privacy-policy"
                    className="text-decoration-none text-white-50"
                  >
                    Privacy Policy
                  </a>
                </li>
                <li className="mb-2">
                  <a
                    href="/refund-policy"
                    className="text-decoration-none text-white-50"
                  >
                    Refund Policy
                  </a>
                </li>
              </ul>
            </div>
          </div>

          {/* Address Row - Full width */}
          <div className="row mt-2 mb-3">
            <div className="col-12">
              <div
                className="footer-address p-3 rounded"
                style={{ background: "rgba(255,255,255,0.05)" }}
              >
                <i
                  className="fas fa-map-marker-alt me-2"
                  style={{ color: "#D4AF37" }}
                ></i>
                <span className="small">
                  <strong>Registered Address:</strong> N0060, Mochpole, Near
                  Junior School, Nabapally, Barasat, Kolkata - 700126, West
                  Bengal, India
                </span>
              </div>
            </div>
          </div>

          <hr className="opacity-25" />
          <div className="text-center small">
            © {currentYear} FORMAX IT SOLUTIONS PRIVATE LIMITED. All rights
            reserved.
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
